import { E2eService } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface PrintInfo {
  isE2e: boolean;
  latestReceipt: string;
  latestLabel: string;
  latestReceiptTemplate: string;
  latestLabelTemplate: string;
  latestPrintLoaded: boolean;
  refreshCounter: number;
}

@Component({
  selector: '[nc-e2e-print-info]',
  templateUrl: './e2e-print-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class E2ePrintInfoComponent implements OnInit {

  printInfo$: Observable<PrintInfo>;
  private refreshCounter = 0;

  constructor(private e2eService: E2eService) {

  }

  ngOnInit(): void {
    this.printInfo$ = combineLatest([
      this.e2eService.getInE2eMode$(),
      this.e2eService.getLabelInfo$(),
      this.e2eService.getReceiptInfo$(),
      this.e2eService.getLabelTemplateInfo$(),
      this.e2eService.getReceiptTemplateInfo$(),
    ]).pipe(
      map(([isE2e, latestLabel, latestReceipt, latestLabelTemplate, latestReceiptTemplate]) => {
        if (!isE2e) {
          return null; // if not in e2e mode then don't show anything
        }

        const vm = {} as PrintInfo;
        vm.isE2e = isE2e;
        vm.latestLabel = latestLabel;
        vm.latestReceipt = latestReceipt;
        vm.latestLabelTemplate = latestLabelTemplate;
        vm.latestReceiptTemplate = latestReceiptTemplate;
        if (!!latestLabel || !!latestReceipt || !!latestLabelTemplate || !!latestReceiptTemplate) {
          vm.latestPrintLoaded = true;
          this.refreshCounter++;
        } else {
          vm.latestPrintLoaded = false;
        }
        vm.refreshCounter = this.refreshCounter;
        return vm;
      }));
  }

  clear(): void {
    this.e2eService.clearCachedData();
  }
}
